export default __webpack_public_path__ + "5f26f1728997956db19788b18d63a09f.svg";